import type { Registry as Services } from '@ember/service';
import { FEATURE_TOGGLES, type FeatureToggle } from 'shared-react/lumen';

export default function createFeatureToggleFlags(
  featureToggle: Services['feature-toggle'],
): FeatureToggle[] {
  if (!featureToggle.featureFlagsAvailable) {
    return [];
  }

  return Object.values(FEATURE_TOGGLES).filter((toggle) =>
    featureToggle.hasFeatureToggle(toggle),
  );
}
